import { Component, Input } from "@angular/core";
import { UITextMode } from "../ui-text/ui-text-mode.enum";
import { UISpinnerStyling } from "./ui-spinner.styling";
import { UIButtonMode } from "../ui-button/ui-button-mode.enum";

@Component({
    selector: 'ui-spinner',
    templateUrl: './ui-spinner.component.html'
})
export class UISpinnerComponent {
    private _mode: UITextMode | UIButtonMode = UITextMode.default;
    private _size: 'small' | 'medium' | 'large';
    @Input() set mode(val: UITextMode | UIButtonMode) {
        this._mode = val;
        this.styling.props.mode = val;
    };
    get mode(): UITextMode | UIButtonMode {
        return this._mode;
    }
    @Input() set size(val: 'small' | 'medium' | 'large') {
        this._size = val;
        this.styling.props.size = val;
    };
    get size(): 'small' | 'medium' | 'large' {
        return this._size;
    }
    UITextMode = UITextMode;

    styling: UISpinnerStyling = new UISpinnerStyling({ mode: this.mode, size: this.size });
}
